import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { FaRegEye, FaUserEdit, FaChartPie, FaHandHoldingHeart } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import axiosInstance from '../../utils/axios';
import { PARTNER_CATEGORIES, CSR_CATEGORIES } from '../../config/permissions.config';
import { setPartnerCategory } from '../../store/features/partnersSlice';

function PartnersTable({ partners, startIndex = 1 }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [savingId, setSavingId] = useState(null);

  const handleCategoryChange = async (adminId, value) => {
    setSavingId(adminId);
    try {
      const { data } = await axiosInstance.put(`/super-admin/partner/${adminId}/category`, {
        category: value || null,
      });
      dispatch(setPartnerCategory({ admin_id: adminId, category: data.category }));
    } catch (err) {
      Swal.fire('Error', err.response?.data?.message || 'Failed to update category', 'error');
    } finally {
      setSavingId(null);
    }
  };

  const getRecords = () => {
    return partners.map((partner, index) => (
      <tr key={index}>
        <td>{startIndex + index}</td>
        <td data-label='COMPANY NAME' className='text-capitalize'>
          {partner.entity_name.toUpperCase()}
        </td>
        <td data-label='LOCATION' className='text-capitalize'>
          {partner.city ? `${partner.city}, ${partner.state}` : 'N/A'}
        </td>
        <td data-label='CATEGORY'>
          <Form.Select
            size='sm'
            aria-label='Partner category'
            value={partner.category || ''}
            disabled={savingId === partner.admin_id}
            onChange={(e) => handleCategoryChange(partner.admin_id, e.target.value)}
          >
            <option value=''>Uncategorized</option>
            {PARTNER_CATEGORIES.map(({ value, label }) => (
              <option key={value} value={value}>{label}</option>
            ))}
          </Form.Select>
        </td>
        <td data-label='DEVICES' className='text-capitalize'>
          {partner.devices}
        </td>
        <td data-label='FARMERS'>{partner.users}</td>
        <td data-label='FIELD OFFICERS'>{partner.officers}</td>
        <td data-label='REPORTS'>{partner.reports}</td>
        <td data-label='ACTIONS'>
          <div className='d-flex justify-content-center gap-2'>
            <Button
              variant='info'
              size='sm'
              onClick={() => navigate(`/partner/dashboard-summary/${partner?.admin_id}`)}
              title="View Dashboard"
              className="text-white"
            >
              <div className='d-flex justify-center align-items-center'>
                <FaChartPie size={18} />
                <span className="d-none d-md-inline ms-1">Dashboard</span>
              </div>
            </Button>

            {CSR_CATEGORIES.includes(partner?.category) && (
              <Button
                variant='success'
                size='sm'
                onClick={() => navigate(`/csr/overview/${partner?.admin_id}`)}
                title="View CSR Impact dashboard"
              >
                <div className='d-flex justify-center align-items-center'>
                  <FaHandHoldingHeart size={18} />
                  <span className="d-none d-md-inline ms-1">CSR</span>
                </div>
              </Button>
            )}

            {/* View/Edit Profile Button */}
            <Button
              variant='primary'
              size='sm'
              onClick={() => navigate(`/partner/profile/${partner?.admin_id}`)}
              title="View Profile"
            >
              <div className='d-flex justify-center align-items-center'>
                <FaUserEdit size={18} />
                <span className="d-none d-md-inline ms-1">Profile</span>
              </div>
            </Button>

            {/* Existing Continue Button */}
            <Button
              variant='success'
              size='sm'
              onClick={() => navigate(`/partners/${partner?.admin_id}`)}
              title="View Field Officers"
            >
              <div className='d-flex justify-center align-items-center'>
                <FaRegEye size={18} />
                <span className="d-none d-md-inline ms-1">Field Officers</span>
              </div>
            </Button>
          </div>
        </td>
      </tr>
    ));
  };

  return (
    <table
      className={`table table-striped text-center table-borderless ${partners.length > 1 ? 'align-middle' : ''
        }`}
    >
      <thead className='table-dark align-top'>
        <tr>
          <th>S.NO.</th>
          <th>COMPANY NAME</th>
          <th>LOCATION</th>
          <th>CATEGORY</th>
          <th>DEVICES</th>
          <th>FARMERS</th>
          <th>FIELD OFFICERS</th>
          <th>REPORTS</th>
          <th>ACTIONS</th>
        </tr>
      </thead>
      <tbody>
        {partners.length > 0 ? (
          getRecords()
        ) : (
          <tr>
            <td className='no-entries' colSpan='10'>
              No Entries Found...
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default PartnersTable;
